import polizaPdf from './polizaPdf'

/*
  Varias pólizas en UN solo archivo, cada una en su propia hoja y con el formato normal de
  póliza. No es un formato nuevo: reusa polizaPdf tal cual, así que lo que se imprime aquí es
  idéntico a abrir cada póliza por separado, y cualquier cambio de formato se sigue haciendo en
  un solo lugar (ver polizaPdf.js).

  Cada elemento de values.polizas es una respuesta de polizas/datosPolizas, es decir lo mismo
  que consume polizaPdf para una sola. El orden de las hojas es el orden del arreglo: quien
  llama lo decide (la trazabilidad de un documento las manda de la más reciente a la más
  antigua).
*/
const polizasDocumentoPdf = (values) => {
    const polizas = values.polizas || []
    if (polizas.length === 0) {
        return {
            pageSize: 'LETTER',
            content: [{ text: 'No hay pólizas que mostrar', alignment: 'center', margin: [0, 40, 0, 0] }],
        }
    }

    // pdfmake sólo tiene marca de agua a nivel documento, no por hoja: si en el mismo archivo
    // van canceladas y vigentes, estampar "CANCELADO" en todas sería mentir. Se conserva sólo
    // cuando TODAS lo están; si no, cada cancelada lleva su propio letrero en su hoja.
    const todasCanceladas = polizas.every((p) => p.poliza?.estado === 0)

    const content = []
    const images = {}
    let watermark = null
    // pdfmake admite un solo juego de styles / defaultStyle / pageMargins / footer por ARCHIVO,
    // no por hoja. Todas las pólizas de una llamada son de la misma empresa —datosPolizas
    // resuelve una sola Empresa para todas—, así que comparten `tipoPDF` y no hay nada que
    // mezclar: las del primer documento que sí se armó valen para el archivo entero.
    //
    // Hay que heredar las cuatro, no sólo `styles`: el diseño moderno trae tipografía propia,
    // márgenes más angostos —sus canvas están dibujados a un ancho fijo calculado con esos
    // márgenes— y el pie de marca con numeración. El clásico no trae ninguna de las tres
    // últimas y sigue saliendo igual que antes. Se cosechan juntas y del MISMO documento para
    // que una póliza que truena no deje, por ejemplo, el `styles` del moderno sin sus márgenes.
    let docProps = null

    polizas.forEach((valuePolizaContable, index) => {
        const cancelada = valuePolizaContable.poliza?.estado === 0
        let documento
        try {
            documento = polizaPdf(valuePolizaContable)
        } catch (error) {
            // Una sola póliza mal formada (por ejemplo sin cargos/abonos, que hace tronar a
            // pdfmake con el body vacío) no debe tumbar la hoja completa: se anota y siguen las
            // demás. Abrirla sola sigue dando el mismo error, que es donde se ve el detalle.
            const numero = valuePolizaContable.poliza?.numeroTipoPoliza
            content.push({
                text: 'No se pudo generar la póliza' + (numero ? ' ' + numero : ''),
                color: '#cf1322',
                bold: true,
                alignment: 'center',
                margin: [0, 20, 0, 0],
                ...(index > 0 ? { pageBreak: 'before' } : {}),
            })
            return
        }

        Object.assign(images, documento.images)
        if (todasCanceladas && !watermark) watermark = documento.watermark
        if (!docProps) {
            docProps = {
                ...(documento.styles ? { styles: documento.styles } : {}),
                ...(documento.defaultStyle ? { defaultStyle: documento.defaultStyle } : {}),
                ...(documento.pageMargins ? { pageMargins: documento.pageMargins } : {}),
                ...(documento.footer ? { footer: documento.footer } : {}),
            }
        }

        const bloques = []
        if (cancelada && !todasCanceladas) {
            bloques.push({
                text: 'PÓLIZA CANCELADA',
                color: '#cf1322',
                bold: true,
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 4],
            })
        }
        bloques.push(...documento.content)

        // La primera hoja no lleva salto: sería una página en blanco al inicio.
        if (index > 0) bloques[0] = { ...bloques[0], pageBreak: 'before' }
        content.push(...bloques)
    })

    return {
        ...(watermark ? { watermark } : {}),
        ...docProps,
        content,
        images,
        pageSize: 'LETTER',
    }
}

export default polizasDocumentoPdf
